/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { allocationSummarySchema } from './allocationSummarySchema';
import { teamWorkAllocationSchema } from './teamWorkAllocationSchema';

export const teamWorkAllocationResponseSchema = z.object({
  get summary() {
    return allocationSummarySchema;
  },
  get teams() {
    return z.array(teamWorkAllocationSchema);
  },
  get unassigned() {
    return z.union([teamWorkAllocationSchema, z.null()]).optional();
  },
});
